import React, { type ReactNode } from 'react';
import { type SwipeableProps, useSwipeable } from 'react-swipeable';
import { toast } from 'react-toastify';

import { Picture } from '../Picture/Picture';

import { Notification } from './Notification';

interface SwipeableToastProps {
  text: string;
  toastId: string | number;
  picture?: { img: string; webp?: string };
}

const SwipeableToast: React.FC<SwipeableToastProps> = ({
  text,
  toastId,
  picture,
}) => {
  // Обробники свайпів з дебагуванням
  const handlers = useSwipeable({
    onSwipedUp: () => toast.dismiss(toastId),
    onSwipedLeft: () => toast.dismiss(toastId),
    onSwipedRight: () => toast.dismiss(toastId),
    delta: 5, // Мінімальна відстань для жесту
    preventScrollOnSwipe: true, // Запобігає прокручуванню під час свайпу
    trackMouse: true, // Дозволити свайп мишею (для тестування на десктопі)
  } as SwipeableProps);

  return (
    <div
      {...handlers}
      className="swipeable-toast-content"
      style={{ touchAction: 'pan-x pan-y' }}
    >
      <Notification
        icon={
          picture
            ? (): ReactNode => (
                <div className="w-10 h-10 shrink-0 !rounded-[50%] overflow-hidden">
                  <Picture
                    // className="w-10 h-10 shrink-0"
                    img={picture.img}
                    webp={picture.webp}
                    alt="link"
                  />
                </div>
              )
            : undefined
        }
        text={text}
      />
    </div>
  );
};

export { SwipeableToast };
